import { api } from '../../shared/api/client';

export interface BankAccount {
  id: string;
  label: string | null;
  bankName: string | null;
  bankAccountName: string | null;
  bankAccountNumber: string | null;
  bankAccountType: 'savings' | 'checking' | null;
  bankBranch: string | null;
  bankSwiftCode: string | null;
}

// Authenticated-only — for the "Payment Details" modal a customer sees against an outstanding invoice.
export function fetchBankInfo(): Promise<BankAccount[]> {
  return api.get<BankAccount[]>('/api/v1/settings/banking');
}
